import { zergApi } from "@/service/zerg";

class EmailEventsService {
    BASE_URL = "setting/general/email";

    async createOrUpdateEmailEvent(params) {
        const url = `${this.BASE_URL}/create-or-update-email-event`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }
    async enableOrDisableEmailEvent(params) {
        const url = `${this.BASE_URL}/enable-or-disable-email-event`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }
    async listEmailEvents(params) {
        const url = `${this.BASE_URL}/list-email-events`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

}

export default new EmailEventsService();